import { screenLabel, type ScreenKey } from '../app/nav'

/**
 * 还没做的那些屏的占位。
 *
 * ## 这一页是 arron 会看到的，不是给我们看的
 *
 * 原来这儿有一张「谁来做」的卡片：任务 ID、`docs/PROGRESS.md`、屏的目录名。
 * 那是并行开工时给干活的人看的——**而它跟着产物一起上线了**，
 * 于是唯一的目标用户点进「排班与技能」，看到的是
 * 「任务 M6-16，流 B。开工前先在 docs/PROGRESS.md 认领」。
 *
 * 他不会知道那是什么，只会知道这个产品在跟他说一件他看不懂的事。
 * **删掉，不替换**——少一句话好过多一句他看不懂的话。
 *
 * 剩下那句还不是模板（这个文件早于文案层），已提给流 0。
 */
const PLAN: Record<ScreenKey, { milestone: string }> = {
  dash: { milestone: 'M1' },
  chat: { milestone: 'M7' },
  memo: { milestone: 'M3' },
  project: { milestone: 'M3' },
  hosts: { milestone: 'M1' },
  code: { milestone: 'M4' },
  sec: { milestone: 'M4' },
  skills: { milestone: 'M6' },
  timeline: { milestone: 'M3' },
  models: { milestone: 'M5' },
  bridge: { milestone: 'M7' },
  vendor: { milestone: 'M3' },
  alert: { milestone: 'M3' },
  team: { milestone: 'M3' },
  auth: { milestone: 'M1' },
  server: { milestone: 'M1' },
  account: { milestone: 'M1' },
  onboard: { milestone: 'M1' },
}

export function Soon({ screen }: { screen: ScreenKey }) {
  const plan = PLAN[screen]

  return (
    <div className="max-w-[1240px] px-npc-page-x pb-npc-page-bottom pt-npc-page-top">
      <h1 className="m-0 font-npc-display text-npc-h1">{screenLabel(screen)}</h1>
      <p className="mb-npc-grid-lg mt-npc-gap-xs text-npc-body-lg text-npc-ink-soft">
        这一屏还没做。外壳与设计系统已经跑通，屏本身在 {plan.milestone}。
      </p>

    </div>
  )
}
